import { render } from "./ShoppingCartSum.vue?vue&type=template&id=53daa255&scoped=true"
import script from "./ShoppingCartSum.vue?vue&type=script&lang=js"
export * from "./ShoppingCartSum.vue?vue&type=script&lang=js"

import "./ShoppingCartSum.vue?vue&type=style&index=0&id=53daa255&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53daa255"]])

export default __exports__